// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Envoltorio y estilo “consulta” solo para OC y documentos */

.consultationTableChrome_tableShell__2maqR {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow-x: auto;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);
}

.consultationTableChrome_tablePremium__Tgs5s thead th {
  background: #f8fafc !important;
  font-weight: normal !important;
  color: #333 !important;
  border-bottom: 1px solid #e2e8f0 !important;
  padding: 12px 14px !important;
}

.consultationTableChrome_tablePremium__Tgs5s tbody td {
  border-bottom: 1px solid #f1f5f9 !important;
  padding: 12px 14px !important;
}

.consultationTableChrome_tablePremium__Tgs5s tbody tr:last-child td {
  border-bottom: none !important;
}

/* Acciones (Detalles + historial): pegada al borde derecho con scroll horizontal */
.consultationTableChrome_tablePremium__Tgs5s thead th:last-child {
  position: sticky;
  right: 0;
  z-index: 3;
  background: #f8fafc !important;
  box-shadow: -10px 0 14px -6px rgba(15, 23, 42, 0.12);
  padding-right: 16px !important;
  min-width: max-content;
}

.consultationTableChrome_tablePremium__Tgs5s tbody td:last-child {
  position: sticky;
  right: 0;
  z-index: 2;
  background-color: #fff !important;
  box-shadow: -10px 0 14px -6px rgba(15, 23, 42, 0.1);
  padding-right: 16px !important;
  vertical-align: middle;
  min-width: max-content;
}

.consultationTableChrome_tablePremium__Tgs5s tbody tr:hover td:last-child {
  background-color: #f3f4f6 !important;
}

.consultationTableChrome_tablePremium__Tgs5s thead th:first-child,
.consultationTableChrome_tablePremium__Tgs5s tbody td:first-child {
  padding-left: 16px !important;
}

/* Tablas consulta (OC/Facturas): recorte visual + mismo contenido en title vía JSX */
.consultationTableChrome_consultationWithIndex__rMVx9 thead th.consultationTableChrome_consultHeadClamp__huQ14:not(:last-child):not(:has(input)) {
  max-width: min(220px, 24vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.consultationTableChrome_consultationWithIndex__rMVx9 thead th.consultationTableChrome_consultHeadIndex__EHR7C:not(:last-child):not(:has(input)) {
  max-width: 3.25rem !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.consultationTableChrome_consultationWithIndex__rMVx9 tbody td.consultationTableChrome_consultTdClamp__Y82BE:not(:last-child) {
  max-width: min(220px, 24vw);
  overflow: hidden;
  vertical-align: middle;
}

.consultationTableChrome_consultationWithIndex__rMVx9 tbody td.consultationTableChrome_consultTdIndex__2JAn9:not(:last-child) {
  max-width: 3.25rem !important;
}

.consultationTableChrome_consultationWithIndex__rMVx9 tbody td.consultationTableChrome_consultTdClamp__Y82BE:not(:last-child) .consultationTableChrome_consultTdHoverTarget__0DqQ5 {
  display: block;
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Tooltip flotante: el title nativo suele no mostrarse dentro de contenedores con overflow + scroll */
.consultationTableChrome_consultFloatTooltip__jIIEt {
  pointer-events: none;
  position: fixed;
  z-index: 100000;
  max-width: min(480px, 92vw);
  max-height: min(320px, 55vh);
  overflow-y: auto;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.94);
  color: #f8fafc;
  font-size: 13px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.22);
}

.consultationTableChrome_detailBtn__zKfQD {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.42rem 0.95rem;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease,
    box-shadow 0.15s ease;
}

.consultationTableChrome_detailBtn__zKfQD:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.consultationTableChrome_historyIconBtn__WoVI- {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.consultationTableChrome_historyIconBtn__WoVI-:hover {
  background: #f1f5f9;
  color: #334155;
}
`, "",{"version":3,"sources":["webpack://./src/components/table/consultationTableChrome.module.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,+EAA+E;AACjF;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mFAAmF;AACnF;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,oDAAoD;EACpD,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,iCAAiC;EACjC,mDAAmD;EACnD,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA,qFAAqF;AACrF;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sGAAsG;AACtG;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB;yBACuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* Envoltorio y estilo “consulta” solo para OC y documentos */\n\n.tableShell {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow-x: auto;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);\n}\n\n.tablePremium thead th {\n  background: #f8fafc !important;\n  font-weight: normal !important;\n  color: #333 !important;\n  border-bottom: 1px solid #e2e8f0 !important;\n  padding: 12px 14px !important;\n}\n\n.tablePremium tbody td {\n  border-bottom: 1px solid #f1f5f9 !important;\n  padding: 12px 14px !important;\n}\n\n.tablePremium tbody tr:last-child td {\n  border-bottom: none !important;\n}\n\n/* Acciones (Detalles + historial): pegada al borde derecho con scroll horizontal */\n.tablePremium thead th:last-child {\n  position: sticky;\n  right: 0;\n  z-index: 3;\n  background: #f8fafc !important;\n  box-shadow: -10px 0 14px -6px rgba(15, 23, 42, 0.12);\n  padding-right: 16px !important;\n  min-width: max-content;\n}\n\n.tablePremium tbody td:last-child {\n  position: sticky;\n  right: 0;\n  z-index: 2;\n  background-color: #fff !important;\n  box-shadow: -10px 0 14px -6px rgba(15, 23, 42, 0.1);\n  padding-right: 16px !important;\n  vertical-align: middle;\n  min-width: max-content;\n}\n\n.tablePremium tbody tr:hover td:last-child {\n  background-color: #f3f4f6 !important;\n}\n\n.tablePremium thead th:first-child,\n.tablePremium tbody td:first-child {\n  padding-left: 16px !important;\n}\n\n/* Tablas consulta (OC/Facturas): recorte visual + mismo contenido en title vía JSX */\n.consultationWithIndex thead th.consultHeadClamp:not(:last-child):not(:has(input)) {\n  max-width: min(220px, 24vw);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.consultationWithIndex thead th.consultHeadIndex:not(:last-child):not(:has(input)) {\n  max-width: 3.25rem !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.consultationWithIndex tbody td.consultTdClamp:not(:last-child) {\n  max-width: min(220px, 24vw);\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n.consultationWithIndex tbody td.consultTdIndex:not(:last-child) {\n  max-width: 3.25rem !important;\n}\n\n.consultationWithIndex tbody td.consultTdClamp:not(:last-child) .consultTdHoverTarget {\n  display: block;\n  box-sizing: border-box;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Tooltip flotante: el title nativo suele no mostrarse dentro de contenedores con overflow + scroll */\n.consultFloatTooltip {\n  pointer-events: none;\n  position: fixed;\n  z-index: 100000;\n  max-width: min(480px, 92vw);\n  max-height: min(320px, 55vh);\n  overflow-y: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: rgba(15, 23, 42, 0.94);\n  color: #f8fafc;\n  font-size: 13px;\n  line-height: 1.4;\n  white-space: pre-wrap;\n  word-break: break-word;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.22);\n}\n\n.detailBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0.42rem 0.95rem;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.detailBtn:hover {\n  background: #f8fafc;\n  border-color: #94a3b8;\n  color: #0f172a;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.historyIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.historyIconBtn:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableShell": `consultationTableChrome_tableShell__2maqR`,
	"tablePremium": `consultationTableChrome_tablePremium__Tgs5s`,
	"consultationWithIndex": `consultationTableChrome_consultationWithIndex__rMVx9`,
	"consultHeadClamp": `consultationTableChrome_consultHeadClamp__huQ14`,
	"consultHeadIndex": `consultationTableChrome_consultHeadIndex__EHR7C`,
	"consultTdClamp": `consultationTableChrome_consultTdClamp__Y82BE`,
	"consultTdIndex": `consultationTableChrome_consultTdIndex__2JAn9`,
	"consultTdHoverTarget": `consultationTableChrome_consultTdHoverTarget__0DqQ5`,
	"consultFloatTooltip": `consultationTableChrome_consultFloatTooltip__jIIEt`,
	"detailBtn": `consultationTableChrome_detailBtn__zKfQD`,
	"historyIconBtn": `consultationTableChrome_historyIconBtn__WoVI-`
};
export default ___CSS_LOADER_EXPORT___;
